import { FormLabel, styled } from "@mui/material";
import { BaseLabelPropsType } from "../../../types/app.type";

export const BaseLabel = styled(FormLabel)<BaseLabelPropsType>(({ colour, fontSize, fontWeight }) => {
    return {
        fontFamily: "Inter",
        fontWeight: fontWeight || 400,
        fontSize: fontSize || "16px",
        lineHeight: "normal",
        color: colour || "#C6C6C6",
        marginBlock: "calc(var(--basic-margin)/4)",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
})